export default {"src":"/_next/static/media/eye.c23cf1a4.svg","height":512,"width":512};